<template>
  <!-- 260611 시안 main_typeC_00 (4): 마케팅 알림 구독 confirm 전용 모달 (공용 CONFIRM 대체) -->
  <div class="mkt-sub-dim" @click.self="close">
    <div class="mkt-sub" role="dialog" aria-modal="true">
      <div class="mkt-sub__body">
        <div class="mkt-sub__head">
          <strong class="mkt-sub__title">마케팅 알림 구독</strong>
          <button type="button" class="mkt-sub__close" aria-label="닫기" @click="close">
            <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true">
              <path d="M5 5 L15 15 M15 5 L5 15" fill="none" stroke="#222" stroke-width="1.6" stroke-linecap="round" />
            </svg>
          </button>
        </div>
        <div class="mkt-sub__divider"></div>
        <p class="mkt-sub__subtitle">이 기업의 마케팅 알림을 받아보시겠어요?</p>
      </div>
      <div class="mkt-sub__actions">
        <button type="button" class="mkt-sub__submit" @click="onSubscribe">구독</button>
        <button type="button" class="mkt-sub__cancel" @click="close">취소</button>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps(['data']);
const emits = defineEmits(['close']);
const { fnSubscribe } = props.data || {};

const onSubscribe = () => {
  if (fnSubscribe) fnSubscribe();
  close();
};

const close = () => {
  setTimeout(() => emits('close'), 200);
};
</script>

<style scoped>
.mkt-sub-dim {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1.6rem;
  background: rgba(0, 0, 0, 0.5);
}
.mkt-sub {
  box-sizing: border-box;
  width: 100%;
  max-width: 34.3rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding: 3rem 2rem;
  background: #fff;
  border-radius: 1.4rem;
}
.mkt-sub__body {
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
}
.mkt-sub__head {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1.4rem;
}
.mkt-sub__title {
  font-size: 2rem;
  font-weight: 700;
  color: #000;
  letter-spacing: -0.03em;
}
.mkt-sub__close {
  flex: 0 0 auto;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  appearance: none;
}
.mkt-sub__divider {
  height: 1px;
  background: #cacaca;
}
.mkt-sub__subtitle {
  margin: 0;
  font-size: 1.6rem;
  font-weight: 400;
  color: #000;
  letter-spacing: -0.03em;
}
.mkt-sub__actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.4rem;
}
.mkt-sub__submit {
  width: 100%;
  height: 5rem;
  padding: 0;
  border: 0;
  border-radius: 1rem;
  background: #30ca22;
  color: #fff;
  font-size: 1.6rem;
  font-weight: 500;
  letter-spacing: -0.3px;
  cursor: pointer;
}
.mkt-sub__submit:active {
  background: #28a81c;
}
.mkt-sub__cancel {
  padding: 0;
  border: 0;
  background: transparent;
  font-size: 1.6rem;
  font-weight: 500;
  color: #959595;
  letter-spacing: -0.3px;
  text-decoration: underline;
  cursor: pointer;
}
</style>
